import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=58022d80"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports